import { useState } from "react";
import { WalletCategory, WalletCategoryText } from "@/domains/wallet";
// components
import { Button, Form, Input, Modal, Select } from "antd";
import { PlusCircleTwoTone } from "@ant-design/icons";

interface WalletCreate {
  category: WalletCategory;
  currency: string;
  address: string;
  note: string;
  daily_deposit_max: string;
  weekly_deposit_max: string;
  monthly_deposit_max: string;
}

export const CreateModal = () => {
  const [form] = Form.useForm<WalletCreate>();

  const [isOpen, setIsOpen] = useState(false);

  const handleShow = () => {
    setIsOpen(true);
    form.resetFields();
  };

  const handleConfirm = async () => {
    const formValue = await form.validateFields();
    console.log(formValue);
    setIsOpen(false);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Button type="primary" icon={<PlusCircleTwoTone />} onClick={handleShow}>
        新增錢包
      </Button>

      <Modal
        title="新增錢包"
        open={isOpen}
        footer={[
          <div className="flex jc:end gap:8" key="footer">
            <Button key="back" onClick={handleCancel}>
              取消
            </Button>
            <Button key="submit" type="primary" onClick={handleConfirm}>
              送出
            </Button>
          </div>,
        ]}
        onCancel={handleCancel}
      >
        <Form className="mt:16" form={form} labelCol={{ span: 6 }}>
          <Form.Item
            label="用途"
            name="category"
            initialValue={WalletCategoryText[WalletCategory.OperatorReceive]}
            rules={[{ required: true, message: "錢包用途不可空白" }]}
          >
            <Select
              allowClear
              placeholder="請選擇錢包用途"
              options={Object.entries(WalletCategoryText)
                .filter(
                  ([key, _]) =>
                    !(
                      key == "0" ||
                      key == "1" ||
                      key == "2" ||
                      key == "10" ||
                      key == "11" ||
                      key == "12" ||
                      key == "99"
                    )
                )
                .map(([key, value]) => ({
                  label: value,
                  value: key,
                }))}
            ></Select>
          </Form.Item>

          <Form.Item
            label="幣種"
            name="currency"
            initialValue="USDT"
            rules={[{ required: true, message: "錢包幣種不可空白" }]}
          >
            <Select
              allowClear
              placeholder="請選擇錢包幣種"
              options={[{ label: "USDT", value: "USDT" }]}
            ></Select>
          </Form.Item>

          <Form.Item
            label="地址"
            name="address"
            rules={[{ required: true, message: "錢包地址不可空白" }]}
          >
            <Input placeholder="請輸入錢包地址" />
          </Form.Item>

          <Form.Item
            label="餘額上限"
            name="balance_max"
            rules={[{ required: true, message: "餘額上限不可空白" }]}
            extra="若設定為 0 則無限制"
          >
            <Input type="number" placeholder="請輸入餘額上限" />
          </Form.Item>

          <Form.Item
            label="日收款上限"
            name="daily_deposit_max"
            rules={[{ required: true, message: "日收款上限不可空白" }]}
            extra="若設定為 0 則無限制"
          >
            <Input type="number" placeholder="請輸入日收款上限" />
          </Form.Item>

          <Form.Item
            label="周收款上限"
            name="weekly_deposit_max"
            rules={[{ required: true, message: "周收款上限不可空白" }]}
            extra="若設定為 0 則無限制"
          >
            <Input type="number" placeholder="請輸入周收款上限" />
          </Form.Item>

          <Form.Item
            label="月收款上限"
            name="monthly_deposit_max"
            rules={[{ required: true, message: "月收款上限不可空白" }]}
            extra="若設定為 0 則無限制"
          >
            <Input type="number" placeholder="請輸入月收款上限" />
          </Form.Item>

          <Form.Item
            label="備註"
            name="note"
            rules={[{ message: "錢包備註不可空白" }]}
          >
            <Input placeholder="請輸入錢包備註" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
